import {createActions} from 'client/framework';

const normalActions = ['INVALIDATE_CLASSROOM', 'SET_ACTIVE_CLASSROOM_ID'];

export default createActions(null, normalActions);
